import BetaBadge from './BetaBadge';

export default BetaBadge;
